import PhoenixArtistsRoles from '../../../phoenix/js/models/artists-roles';
import { _T } from '../../../phoenix/js/globals';

class LegacyArtistsRoles {
    constructor(artists, roles, rolesExceptions) {
        const filteredArtists = artists.reduce((total, actual) => {
            const filteredRoles = actual.roles.filter(role => !rolesExceptions.includes(role));

            if (filteredRoles.length !== 0) {
                total.push({
                    name: actual.artist.name,
                    roles: filteredRoles.map(role => roles[role])
                });
            }

            return total;
        }, []);

        this.artistsRoles = new PhoenixArtistsRoles(filteredArtists);
    }

    namesByRolesToHTML() {
        const roles = this.artistsRoles.namesByRoles();

        return Object.keys(roles).reduce((total, actual) => {
            total.push(`<strong>${_T(actual)}</strong>: ${roles[actual].join(' | ')}`);

            return total;
        }, []).join('<br>');
    }
}

window.ArtistsRoles = LegacyArtistsRoles;
